var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-block"},[_c('v-icon',{attrs:{"x-small":""}},[_vm._v(_vm._s(_vm._f("proxy")(_vm.item.proxy)))]),_c('v-icon',{attrs:{"x-small":""}},[_vm._v(_vm._s(_vm.typeIcon))]),_c('div',[_vm._v(_vm._s(_vm.item.orderNumber))]),_c('div',[_vm._v(_vm._s(_vm._f("truncate")(_vm.item?.seller?.name,18)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }